import axios from 'axios';
import md5 from 'md5';
import {
    TRENDING_KEYWORDS_WIDGET_DATA_KEY,
    TRENDING_KEYWORDS_WIDGET_PREVIOUS_DATA_KEY
} from '@/assets/dashboard/cache-keys';
import toSnakeCaseThenStringify from '@/helpers/toSnakeCaseThenStringify';

export const state = () => ({
    cache: {}
});

export const getters = {
    DATA_KEY: () => TRENDING_KEYWORDS_WIDGET_DATA_KEY,
    PREVIOUS_DATA_KEY: () => TRENDING_KEYWORDS_WIDGET_PREVIOUS_DATA_KEY,
    cache: state => state.cache
};

export const mutations = {
    SET_CACHE(state, { key, data }) {
        state.cache[key] = data;
    },

    FLUSH_CACHE(state) {
        state.cache = {}
    },
};

export const actions = {
    index(
        { getters, commit },
        { limit, range, comparedRange, accountId, timeZone, properties, sort, order, search, ...additionalParams }
    ) {
        return new Promise(
            (resolve, reject) => {
                const params = {
                    ...additionalParams,
                    range,
                    comparedRange: comparedRange,
                    limit,
                    timeZone,
                    accountId,
                    sort,
                    order,
                    keyword: search,
                    properties: toSnakeCaseThenStringify(properties)
                };

                const cacheKey = md5(JSON.stringify(params));

                if (getters.cache[cacheKey]) {
                    resolve(getters.cache[cacheKey]);
                } else {
                    axios
                        .getMethodOverridePost('/v1/dashboard/entities', { params, encodeURI: true })
                        .then(data => {
                            commit('SET_CACHE', { key: cacheKey, data: data });
                            resolve(data);
                        })
                        .catch((e) => reject(e))
                        .finally(() => commit('SET_PROMISE', undefined));
                }
            });
    },

    csv(vuexContext, { limit, range, comparedRange, accountId, timeZone, properties, sort, order }) {
        const params = {
            range,
            comparedRange: comparedRange,
            limit,
            timeZone,
            accountId,
            sort,
            order,
            properties: toSnakeCaseThenStringify(properties)
        };

        return axios.getMethodOverridePostWithHeaders('/v1/dashboard/entities.csv', { params, encodeURI: true });
    },

    flushCache({ commit }) {
        commit('FLUSH_CACHE');
    }
};
